var render, staticRenderFns
import script from "./Upgradable.vue?vue&type=script&lang=js"
export * from "./Upgradable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f61d6a0')) {
      api.createRecord('7f61d6a0', component.options)
    } else {
      api.reload('7f61d6a0', component.options)
    }
    
  }
}
component.options.__file = "src/components/mixins/Upgradable.vue"
export default component.exports